import { faEdit, faTrashAlt, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { Component, inject, OnInit } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { IconsService } from 'src/app/shared/services/icons.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-tenant-users',
  template: `
  <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Clientes</h1>
      </div>
      <div class="ms-3 me-3 mt-2">
        <input class="form-control rounded-2 border-2 bg-transparent" placeholder="Buscar..." [formControl]="searchControl">
      </div>
      <div class="ms-auto text-end mt-2">          
        <button class="btn btn-zazz-dark ms-2 shadow-sm" *ngIf="authService.hasPermission('can_create_tenants')" routerLink="/condominios/create/condominio">
          <fa-icon [icon]="icons.faPlus" class="me-0 me-md-2"></fa-icon>
          <span class="d-none d-sm-none d-md-inline-block">Dar de alta cliente</span>
        </button>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">
        <ul #subnav app-nav-settlements [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          

          <!-- app-filter-full
              [profile]="profile"
              [toDate]="toDate"
              [fromDate]="fromDate"
              [payload]="payFilterPrefs"
              (billsSettlement)="loadTenantsBySettlement($event)"
              (billsBuilding)="loadTenantsByBuilding($event)"
              (billsFloor)="loadTenantsByFloor($event)"
              (billsUnit)="loadTenantsByUnit($event)"
              (billsSort)="loadTenantsSort($event)"
              (billsOrder)="loadTenantsOrder($event)"
              (billsPerPage)="loadTenantsPerPage($event)"
              (dateRange)="updateDate($event)"
              (clear)="clearFilter()"
            ></app-filter-full -->
        </div>
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-2">
            Inquilinos <span class="text-muted" style="font-size: 0.5em;">({{meta?.total_entries}})</span>
          </div>
          <div class="list-group-item table-responsive py-4">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3">Nombre</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2 d-none d-md-table-cell">Correo electrónico</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Unidades</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">THSM</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2"></th>
                </tr>
              </thead>
              <tbody>
              <tr app-tr-tenant 
                [tenant]="user"
                *ngFor="let user of users | paginate: { 
                  itemsPerPage: payload.per_page, 
                  currentPage: p, 
                  totalItems: meta.total_entries 
                  }"
              ></tr>
              </tbody>
            </table>
            <div class="text-center py-5" *ngIf="users.length==0&&loading">
              <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
              <p class="text-muted">Cargando...</p>
            </div>
            <div class="text-center py-5" *ngIf="users.length==0&&!loading" >
              <img src="/assets/images/empty-state.png" width="240px">
              <p class="text-muted">No se encontraron registros</p>
            </div>
          </div>
          <div class="list-group-item text-center pt-3">
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"
              *ngIf="users.length>0"
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class TenantUsersComponent implements OnInit {
  loading: boolean = false;
  users: any[] = [];
  meta: any = {};
  profile: any = {};
  permissions: any = {};
  searchBox: FormGroup = new FormGroup({});

  payload: any = {
    page: 1,
    per_page: 30,
  };

  a = new Date();
  fromDate; // : any = "2023/12/01"; // Date = new Date();
  toDate; // : any = "2024/02/02"; // Date = new Date();

  p: number = 1;

  payFilterPrefs: any = {};

  searchControl: FormControl = new FormControl();
  currentView: string = 'tenants';
  storageService = inject(StorageService);
  errorHandler = (err: any) => {
        console.log(err);
        this.toastr.warning('No se encontraron registros', 'Error');
        this.users = [];
        this.loading = false;
  }
  constructor(
    private store: SettlementsService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public icons: IconsService,
    public authService: AuthService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.payload.profile_id = this.profile.id;

    this.fromDate = new NgbDate(this.a.getFullYear(), this.a.getMonth(), 1);
    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, 29);

    this.payload.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
    this.payload.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;

    this.payFilterPrefs = this.storageService.getItem(STORAGE_KEYS.PAYFILTERSPREFS) ? this.storageService.getItem(STORAGE_KEYS.PAYFILTERSPREFS) : this.payload;
    this.payFilterPrefs.state = 0;
    this.payFilterPrefs.profile_id = this.profile.id;
    this.payFilterPrefs.status = false;
    this.payFilterPrefs.state = 0;
    this.p = this.payFilterPrefs.page;

    this.loadUsers(this.payload);
  }

  ngOnInit() {    
    
    this.initForm(); 
    this.searchControl.valueChanges.pipe(
      tap(() => this.loading = true),
      debounceTime(200),
      distinctUntilChanged(),
      switchMap((search) => 
        (search && search.trim().length > 0)
          ? this.store.getTenantsQuery({ search })
          : this.store.getTenantsQuery(this.payload)
      )
    ).subscribe({
      next: (users = []) => {
        this.users = users.data;
        this.meta = users.meta;
        this.loading = false;
      },
      error: this.errorHandler
    })
  }

  loadUsers(payload: any) {
    this.loading = true;
    this.store.getTenantsQuery(payload).subscribe({
      next: (users: any) => {
        console.log('tenants >= ', users);
        this.loading = false;
        this.users = users.data;
        this.meta = users.meta;
        
      },
      error: this.errorHandler
    });
  }

  initForm() {
    this.searchBox = this.fb.group({
      search: ['']
    })
  }

  searchUsers(event: any) {
    this.payload.page = 1;
    this.payload.name = this.searchBox.value.search;
    this.loadUsers(this.payload);
  }

  pageChanged(event: any) {
    this.payload.page = event;
    console.log('payload => ', this.payload)
    this.loadUsers(this.payload);
  }

  removeUser(id: number) {
    this.store.destroyUser(id).subscribe({
      next: (data: any) => {
        this.toastr.success('Usuario eliminado correctamente.', 'Éxito');
        this.loadUsers(this.payload);
      },
      error: (err: any) => {
        this.toastr.error('Ocurrió un error al eliminar el usuario.', 'Error');        
      },
    });
  }

  updateDate(event: any) {
    this.fromDate = event.from;
    this.toDate = event.to;

    if (this.toDate.after(this.fromDate) || this.toDate.equals(this.fromDate)) {
      this.payFilterPrefs.created_at_since = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
      this.payFilterPrefs.created_at_to = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
      this.loadUsers(this.payFilterPrefs);
    }
  }

  loadTenantsBySettlement(settlement_id: any) {
    this.payFilterPrefs.settlement_id = settlement_id;    
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.building_id;
    delete this.payFilterPrefs.floor_id;
    delete this.payFilterPrefs.unit_id;

    this.loadUsers(this.payFilterPrefs);
  }

  loadTenantsByBuilding(building_id: any) {
    this.payFilterPrefs.building_id = building_id;
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.floor_id;
    delete this.payFilterPrefs.unit_id;

    this.loadUsers(this.payFilterPrefs);
  }

  loadTenantsByFloor(floor_id: any) {
    this.payFilterPrefs.floor_id = floor_id;
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.unit_id;

    this.loadUsers(this.payFilterPrefs);
  }

  loadTenantsByUnit(unit_id: any) {
    this.payFilterPrefs.unit_id = unit_id;
    this.payFilterPrefs.page = 1;
    this.p = 1;

    this.loadUsers(this.payFilterPrefs);
  }

  loadTenantsSort(event: any) {
    this.payFilterPrefs.sort = event;
    this.loadUsers(this.payFilterPrefs);
  }

  loadTenantsOrder(event: any) {
    this.payFilterPrefs.order = event;
    this.loadUsers(this.payFilterPrefs);
  }

  loadTenantsPerPage(event: any) {
    this.payFilterPrefs.per_page = parseInt(event);
    this.loadUsers(this.payFilterPrefs);
  }

  clearFilter() {    
    this.payFilterPrefs.page = 1;
    this.p = 1;

    delete this.payFilterPrefs.settlement_id;
    delete this.payFilterPrefs.building_id;
    delete this.payFilterPrefs.floor_id;
    delete this.payFilterPrefs.unit_id;

    this.loadUsers(this.payFilterPrefs);
  }

}
